(function () {
  const STORAGE_KEY = "df_gacha_closed_v11";
  const GACHA_COLLECTION_URL = "/collections/gaca-gaca-online/products.json?limit=250";

  const loadingSteps = [
    "Finding curated product...",
    "Reading product story...",
    "Mapping Japan capsule category...",
    "Preparing discovery experience..."
  ];

  function formatMoney(value) {
    const number = Number(value);
    if (!value || Number.isNaN(number)) return "";
    return "¥" + new Intl.NumberFormat("ja-JP").format(number);
  }

  function getRandomItem(items) {
    return items[Math.floor(Math.random() * items.length)];
  }

  function getRandomCapsuleColor() {
    const colors = [
      "linear-gradient(90deg, #18c4ff 50%, #fff 50%)",
      "linear-gradient(90deg, #ff2fb3 50%, #fff 50%)",
      "linear-gradient(90deg, #7b61ff 50%, #fff 50%)",
      "linear-gradient(90deg, #ffcc33 50%, #fff 50%)",
      "linear-gradient(90deg, #111 50%, #fff 50%)"
    ];

    return getRandomItem(colors);
  }

  async function fetchGachaProducts() {
    try {
      const response = await fetch(GACHA_COLLECTION_URL, {
        method: "GET",
        headers: { Accept: "application/json" }
      });

      if (!response.ok) throw new Error("Failed to fetch products");

      const data = await response.json();
      return Array.isArray(data.products) ? data.products : [];
    } catch (error) {
      console.warn("DF Gacha fetch failed:", error);
      return [];
    }
  }

  function getImageUrl(product) {
    if (product?.images?.length > 0) return product.images[0].src;
    if (product?.image?.src) return product.image.src;
    return "";
  }

  function getProductPrice(product) {
    if (product?.variants?.length > 0) return product.variants[0].price;
    return "";
  }

  function makeProductStory(product) {
  const title = product && product.title ? product.title : "Japan Capsule Product";
  const vendor = product && product.vendor ? product.vendor : "DIR'S FACTORY STORE";
  const capsuleName = getCapsuleName(product);

  return (
    "DIRLAIN AI memilih " +
    title +
    " dari " +
    vendor +
    " ke dalam " +
    capsuleName +
    ". Produk ini dipilih karena membawa nuansa Jepang, memiliki nilai discovery, dan cocok untuk hadiah, koleksi, atau daily style."
  );
}

  function openPopup() {
    const popup = document.getElementById("dfGachaPopup");
    if (!popup) return;

    popup.classList.add("is-active");
    popup.setAttribute("aria-hidden", "false");

    document.documentElement.classList.add("df-gacha-open");
    document.body.classList.add("df-gacha-open");
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  }

  function closePopup() {
    const popup = document.getElementById("dfGachaPopup");
    if (!popup) return;

    popup.classList.remove("is-active", "is-opening", "is-drop", "is-result");
    popup.setAttribute("aria-hidden", "true");

    document.documentElement.classList.remove("df-gacha-open");
    document.body.classList.remove("df-gacha-open");
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";

    localStorage.setItem(STORAGE_KEY, "true");
  }

  function playLoadingText() {
    const loadingText = document.getElementById("dfGachaLoadingText");
    let index = 0;

    if (!loadingText) return null;

    loadingText.textContent = loadingSteps[index];

    return setInterval(function () {
      index += 1;
      if (index >= loadingSteps.length) index = 0;
      loadingText.textContent = loadingSteps[index];
    }, 520);
  }

function getCapsuleName(product) {
  const title = (product && product.title ? product.title : "").toLowerCase();

  if (title.includes("samurai")) return "Samurai Spirit Capsule";
  if (title.includes("tokyo")) return "Tokyo Street Capsule";
  if (title.includes("osaka")) return "Osaka Daily Capsule";
  if (title.includes("yokoso")) return "Welcome Japan Capsule";
  if (title.includes("miyagi")) return "Japan Omiyage Capsule";
  if (title.includes("aomori")) return "Aomori Culture Capsule";
  if (title.includes("kanji")) return "Japanese Typography Capsule";

  return "Japan Discovery Capsule";
}

  function renderProductResult(product) {
    const reward = document.getElementById("dfGachaReward");
    const story = document.getElementById("dfGachaStory");
    const link = document.getElementById("dfGachaProductLink");

    const productCard = document.getElementById("dfGachaProductCard");
    const productImage = document.getElementById("dfGachaProductImage");
    const productVendor = document.getElementById("dfGachaProductVendor");
    const productTitle = document.getElementById("dfGachaProductTitle");
    const productPrice = document.getElementById("dfGachaProductPrice");

    const imageUrl = getImageUrl(product);
    const price = getProductPrice(product);

    if (reward) reward.textContent = getCapsuleName(product);
    if (story) story.textContent = makeProductStory(product);

    if (link) {
      link.href = product?.handle
        ? "/products/" + product.handle
        : "/collections/gaca-gaca-online";
    }

    if (productCard) productCard.hidden = false;

    if (productImage) {
      productImage.src = imageUrl;
      productImage.alt = product?.title || "Gacha product";
      productImage.style.display = imageUrl ? "block" : "none";
    }

    if (productVendor) {
      productVendor.textContent = product?.vendor || "DIR'S FACTORY STORE";
    }

    if (productTitle) {
      productTitle.textContent = product?.title || "Japan Capsule Product";
    }

    if (productPrice) {
      productPrice.textContent = formatMoney(price);
    }
  }

  function renderFallbackResult() {
    const reward = document.getElementById("dfGachaReward");
    const story = document.getElementById("dfGachaStory");
    const link = document.getElementById("dfGachaProductLink");
    const productCard = document.getElementById("dfGachaProductCard");

    if (reward) reward.textContent = "Japan Souvenir Capsule";
    if (story) {
      story.textContent =
        "DIRLAIN AI menemukan capsule souvenir Jepang dari collection GACA-GACA ONLINE.";
    }
    if (link) link.href = "/collections/gaca-gaca-online";
    if (productCard) productCard.hidden = true;
  }

  function resetResult() {
    const popup = document.getElementById("dfGachaPopup");
    const machine = document.getElementById("dfGachaMachine");
    const result = document.getElementById("dfGachaResult");
    const loading = document.getElementById("dfGachaLoading");
    const start = document.getElementById("dfGachaStart");
    const screen = document.getElementById("dfGachaScreen");
    const fallingCapsule = document.getElementById("dfGachaFallingCapsule");
    const productCard = document.getElementById("dfGachaProductCard");

    if (popup) popup.classList.remove("is-opening", "is-drop", "is-result");
    if (machine) machine.hidden = false;
    if (result) result.hidden = true;
    if (loading) loading.hidden = true;
    if (productCard) productCard.hidden = true;

    if (start) {
      start.style.display = "inline-flex";
      start.disabled = false;
      start.textContent = "TURN THE GACHA";
    }

    if (screen) screen.textContent = "READY";
    if (fallingCapsule) fallingCapsule.style.background = getRandomCapsuleColor();
  }

  async function openCapsule() {
    const popup = document.getElementById("dfGachaPopup");
    const machine = document.getElementById("dfGachaMachine");
    const start = document.getElementById("dfGachaStart");
    const loading = document.getElementById("dfGachaLoading");
    const result = document.getElementById("dfGachaResult");
    const screen = document.getElementById("dfGachaScreen");
    const fallingCapsule = document.getElementById("dfGachaFallingCapsule");

    if (!popup || !start || start.disabled) return;

    if (result) result.hidden = true;
    if (loading) loading.hidden = false;
    if (fallingCapsule) fallingCapsule.style.background = getRandomCapsuleColor();

    start.disabled = true;
    start.textContent = "TURNING...";
    popup.classList.add("is-opening");

    if (screen) screen.textContent = "AI";

    const loadingInterval = playLoadingText();
    const productsPromise = fetchGachaProducts();

    setTimeout(function () {
      popup.classList.remove("is-opening");
      popup.classList.add("is-drop");

      if (screen) screen.textContent = "OPEN";
      start.textContent = "OPENING...";
    }, 1500);

    setTimeout(async function () {
      if (loadingInterval) clearInterval(loadingInterval);

      const products = await productsPromise;

      popup.classList.remove("is-drop");
      popup.classList.add("is-result");

      if (loading) loading.hidden = true;
      if (machine) machine.hidden = true;
      if (screen) screen.textContent = "DONE";

      if (products.length > 0) {
        renderProductResult(getRandomItem(products));
      } else {
        renderFallbackResult();
      }

      if (result) result.hidden = false;

      start.style.display = "none";
    }, 2800);
  }

  function initGacha() {
    const popup = document.getElementById("dfGachaPopup");
    if (!popup) return;

    const start = document.getElementById("dfGachaStart");
    const again = document.getElementById("dfGachaAgain");
    const knob = document.getElementById("dfGachaKnob");
    const closeButtons = popup.querySelectorAll("[data-df-gacha-close]");

    closeButtons.forEach(function (button) {
      button.addEventListener("click", closePopup);
    });

    if (start) start.addEventListener("click", openCapsule);
    if (knob) knob.addEventListener("click", openCapsule);

    if (again) {
      again.addEventListener("click", function () {
        resetResult();
        setTimeout(openCapsule, 120);
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && popup.classList.contains("is-active")) {
        closePopup();
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initGacha();

    const alreadyClosed = localStorage.getItem(STORAGE_KEY);
    if (alreadyClosed) return;

    setTimeout(function () {
      openPopup();
    }, 900);
  });
})();